import { createClient } from '@/shared/api';
import type {
  ClinicRmaShipmentReminderMutation,
  ClinicRmaShipmentReminderMutationVariables,
} from '@/shared/api';
import CLINIC_RMA_SHIPMENT_REMINDER_MUTATION from '../mutations/clinicRmaShipmentReminder';

/**
 * Sends or clears a clinic shipment reminder on an RMA ticket. Runs CLINIC_RMA_SHIPMENT_REMINDER_MUTATION and throws the returned message when isSuccess is false.
 *
 * @param ticketId - Identifier of the RMA ticket to remind on.
 * @param isReminder - Whether the reminder is being set or cleared.
 * @returns A promise resolving once the mutation result has been checked for success.
 */
const handleClinicRmaShipmentReminder = async (ticketId: any, isReminder: any) => {
  const client = createClient();
  const result = await client.mutate<
    ClinicRmaShipmentReminderMutation,
    ClinicRmaShipmentReminderMutationVariables
  >({
    mutation: CLINIC_RMA_SHIPMENT_REMINDER_MUTATION,
    variables: {
      ticketId,
      isReminder,
    },
  });
  // client.mutate's default errorPolicy throws before this line on any GraphQL error, so data is always present here.
  const { clinicRmaShipmentReminder } = result.data!;
  const { isSuccess, message } = clinicRmaShipmentReminder!;
  if (!isSuccess) {
    throw new Error(message ?? undefined);
  }
};

export default handleClinicRmaShipmentReminder;
